/**
 * 장착 순서
 */
export const repairMarkerForm = [
  { key: 1, title: "결제완료", date: "paymentCompletedAt" },
  { key: 3, title: "주문확정", date: "orderConfirmedAt" },
  { key: 5, title: "출고의뢰", date: "goodsIssueRequestedAt" },
  { key: 7, title: "출고완료", date: "goodsIssueCompletedAt" },
  { key: 9, title: "작업완료", date: "serviceCompletedAt" },
  { key: 11, title: "구매확정", date: "purchaseConfirmedAt" },
];
